import { FC } from 'react';
import { useUser } from '@/hooks/use-user';
export const AccountPage: FC = () => {
  const { user } = useUser();

  return (
    <>
      <h1>My Account</h1>
      <p>Hello {user.firstName}</p>
    </>
  );
};
